var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2.1283L15.2475 4.38366V1.27062C15.2475 0.933634 15.1136 0.610446 14.8753 0.372157C14.6371 0.133869 14.3139 0 13.9769 0H2.54125C1.86727 0 1.22089 0.267738 0.744315 0.744315C0.267738 1.22089 0 1.86727 0 2.54125V12.7063C0 13.3802 0.267738 14.0266 0.744315 14.5032C1.22089 14.9798 1.86727 15.2475 2.54125 15.2475H13.9769C14.3139 15.2475 14.6371 15.1136 14.8753 14.8753C15.1136 14.6371 15.2475 14.3139 15.2475 13.9769V10.8511L19.25 13.1065C19.3527 13.1736 19.4712 13.2125 19.5937 13.2192C19.7161 13.226 19.8382 13.2004 19.9477 13.1451C20.0571 13.0897 20.1501 13.0065 20.2172 12.9038C20.2843 12.8011 20.3232 12.6826 20.33 12.5601V2.66831C20.3222 2.54638 20.2825 2.42864 20.215 2.32682C20.1474 2.225 20.0544 2.14266 19.9451 2.08802C19.8358 2.03338 19.7141 2.00835 19.5922 2.01542C19.4702 2.02248 19.3522 2.0614 19.25 2.1283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2fc83063434038137aa8afa7ee27cb6a.svg";
export { ForwardRef as ReactComponent };